import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
import FormMixin from '@/amui-fe/mixins/formMixin';
let AmFeTagField = class AmFeTagField extends Mixins(FormMixin) {
  constructor() {
    super(...arguments);
    this.visible = false;
    this.inputValue = '';
  }
  get tags() {
    var _this$value;
    return !!((_this$value = this.value) !== null && _this$value !== void 0 && _this$value.trim()) ? this.value.split(',') : [];
  }
  get buttonSize() {
    const sizeMap = new Map([['mini', 'small'], ['small', 'medium'], ['medium', 'large']]);
    return sizeMap.get(this.size);
  }
  setTags(v) {
    this.change(v.join(','));
  }
  handleClose(tag) {
    if (this.disabled || this.readonly) {
      return;
    }
    this.tags.splice(this.tags.indexOf(tag), 1);
    this.setTags(this.tags);
  }
  showInput() {
    if (this.disabled || this.readonly) {
      return;
    }
    this.visible = true;
    this.$nextTick(() => {
      ;
      this.$refs.saveTagInput.$refs.input.focus();
    });
  }
  handleInputConfirm() {
    let inputValue = this.inputValue;
    if (inputValue) {
      this.tags.push(inputValue);
      this.setTags(this.tags);
    }
    this.visible = false;
    this.inputValue = '';
  }
  get label_i18n() {
    return this.label === '选择标签' ? window.lowcode.i18n.get('apaas_amui_tagfield_label', '选择标签') : this.label;
  }
};
AmFeTagField.componentName = 'AmFeTagField';
__decorate([Prop()], AmFeTagField.prototype, "type", void 0);
__decorate([Prop({
  default: true
})], AmFeTagField.prototype, "closable", void 0);
__decorate([Prop({
  default: true
})], AmFeTagField.prototype, "hit", void 0);
__decorate([Prop()], AmFeTagField.prototype, "effect", void 0);
AmFeTagField = __decorate([Component({
  name: 'AmFeTagField'
})], AmFeTagField);
export default AmFeTagField;